/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteUnproxiedMcpServerSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type DeleteUnproxiedMcpServerSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type DeleteUnproxiedMcpServerSecurity = {
  option1?: DeleteUnproxiedMcpServerSecurityOption1 | undefined;
  option2?: DeleteUnproxiedMcpServerSecurityOption2 | undefined;
};

export type DeleteUnproxiedMcpServerRequest = {
  /**
   * The ID of the unproxied MCP server to delete
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type DeleteUnproxiedMcpServerSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const DeleteUnproxiedMcpServerSecurityOption1$outboundSchema:
  z.ZodMiniType<
    DeleteUnproxiedMcpServerSecurityOption1$Outbound,
    DeleteUnproxiedMcpServerSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function deleteUnproxiedMcpServerSecurityOption1ToJSON(
  deleteUnproxiedMcpServerSecurityOption1:
    DeleteUnproxiedMcpServerSecurityOption1,
): string {
  return JSON.stringify(
    DeleteUnproxiedMcpServerSecurityOption1$outboundSchema.parse(
      deleteUnproxiedMcpServerSecurityOption1,
    ),
  );
}

/** @internal */
export type DeleteUnproxiedMcpServerSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const DeleteUnproxiedMcpServerSecurityOption2$outboundSchema:
  z.ZodMiniType<
    DeleteUnproxiedMcpServerSecurityOption2$Outbound,
    DeleteUnproxiedMcpServerSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function deleteUnproxiedMcpServerSecurityOption2ToJSON(
  deleteUnproxiedMcpServerSecurityOption2:
    DeleteUnproxiedMcpServerSecurityOption2,
): string {
  return JSON.stringify(
    DeleteUnproxiedMcpServerSecurityOption2$outboundSchema.parse(
      deleteUnproxiedMcpServerSecurityOption2,
    ),
  );
}

/** @internal */
export type DeleteUnproxiedMcpServerSecurity$Outbound = {
  Option1?: DeleteUnproxiedMcpServerSecurityOption1$Outbound | undefined;
  Option2?: DeleteUnproxiedMcpServerSecurityOption2$Outbound | undefined;
};

/** @internal */
export const DeleteUnproxiedMcpServerSecurity$outboundSchema: z.ZodMiniType<
  DeleteUnproxiedMcpServerSecurity$Outbound,
  DeleteUnproxiedMcpServerSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => DeleteUnproxiedMcpServerSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => DeleteUnproxiedMcpServerSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function deleteUnproxiedMcpServerSecurityToJSON(
  deleteUnproxiedMcpServerSecurity: DeleteUnproxiedMcpServerSecurity,
): string {
  return JSON.stringify(
    DeleteUnproxiedMcpServerSecurity$outboundSchema.parse(
      deleteUnproxiedMcpServerSecurity,
    ),
  );
}

/** @internal */
export type DeleteUnproxiedMcpServerRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const DeleteUnproxiedMcpServerRequest$outboundSchema: z.ZodMiniType<
  DeleteUnproxiedMcpServerRequest$Outbound,
  DeleteUnproxiedMcpServerRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function deleteUnproxiedMcpServerRequestToJSON(
  deleteUnproxiedMcpServerRequest: DeleteUnproxiedMcpServerRequest,
): string {
  return JSON.stringify(
    DeleteUnproxiedMcpServerRequest$outboundSchema.parse(
      deleteUnproxiedMcpServerRequest,
    ),
  );
}
